import backofficeService from '../../api/backoffice'
// import publicService from '../../api/public'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('transaction', {
        params: { ...params, _requestTime: Date.now() }
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  getAllTransactionByInvoice(id) {
    return backofficeService.Api().get(`transaction/invoice/${id}`)
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  

  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    // console.log('getby id', id)
    return backofficeService.Api().get(`transaction/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  

  last(params = {}) {
    return backofficeService.Api().get(`invoiceDetail/last`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('transaction', data)
      .then(response => {
        document.dispatchEvent(event)
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`transaction/${id}`, data)
      .then(response => {
        document.dispatchEvent(event)
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  adjustCost(id, data) {
    return backofficeService.Api().put(`invoice/adjustCost/${id}`, data)
      .then(response => {
        document.dispatchEvent(event)
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`transaction/${id}`, {
        params
      })
      .then(response => {
        document.dispatchEvent(event)
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

}
